import IconComponent from "@/components/helpers/iconComponent/iconComponent";
import { Text, TextInput, Stack } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import styles from "./inputText.module.scss";
import { isNil } from "lodash";
export interface InputTextProps {
  name: string;
  label: string;
  placeholder: string;
  validators: { type: string; args: string }[];
  value: string;
  icon?: { name: string; stroke: string; color: string };
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  isSubmitted: boolean;
  hasError: (invalid: boolean) => void;
  onChange: (value: string) => void;
}

export function InputText(props: InputTextProps) {
  const ref = useRef<HTMLInputElement>(null);
  const icon = props.icon ? (
    <IconComponent
      name={props.icon.name}
      stroke={props.icon.stroke}
      size={16}
      color={props.icon.color ?? "currentColor"}
    />
  ) : undefined;
  const [error, setError] = useState<string[]>([]);
  const [hasEdited, setHasEdited] = useState<boolean>(false);

  useEffect(() => {
    if (ref.current) {
      ref.current.value = props.value || "";
      validate(props.value);
    }
  }, [props.value]);

  useEffect(() => {
    props.hasError(error.length > 0 && error.some((e) => e));
  }, [error]);

  const validate = (value: string) => {
    let errArr: string[] = props.validators?.map((v) => {
      switch (v?.type) {
        case "required":
          return isNil(value) || value === "" ? "Trường bắt buộc" : null;
        case "regex": {
          return RegExp(v.args ?? "")?.test(value)
            ? null
            : "Email không đúng định dạng";
        }
      }
    });
    setError(errArr?.filter((e) => e !== null) ?? []);
  };

  useEffect(() => {
    setHasEdited(false);
  }, [props.isSubmitted]);

  return (
    <Stack spacing={8}>
      <TextInput
        ref={ref}
        label={props.label}
        placeholder={props.placeholder}
        icon={icon}
        defaultValue={props.value}
        onChange={(e) => {
          props.onChange(e.currentTarget.value);
          validate(e.currentTarget.value);
          setHasEdited(true);
        }}
        size={props.size ?? "md"}
        radius={100}
        classNames={{
          input: styles.input,
          icon: styles.icon,
        }}
      />
      <Stack spacing={0} pl={15}>
        {hasEdited &&
          error?.map((e, idx) => (
            <Text key={idx} color="red" fz={13}>
              {e}
            </Text>
          ))}
      </Stack>
    </Stack>
  );
}
